module.exports = __webpack_public_path__ + "assets/img/card-exclamation.e391c909.png";